import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IResOrder, Order } from '@/types/plugins/mlParcel';

interface Props {
  order: Order | null;
  clientId: string;
  isOpen: boolean;
}

const useDetailsModalParcel = ({ order, clientId, isOpen }: Props) => {
  const [downloadModal, setDownloadModal] = useState(false);
  const [orderData, setOrderData] = useState<Order | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleDownloadModal = () => setDownloadModal((prev) => !prev);

  const downloadLabels = async ({
    pageSize,
    trackingIds,
  }: {
    pageSize: 'small' | 'letter' | 'zebra';
    trackingIds: string[];
  }) => {
    const http = initializeHttpProvider();
    try {
      const response = await http.orders.labels({ pageSize, trackingIds });
      if ('data' in response && !Array.isArray(response.data) && response.data.url) {
        window.open(response.data.url, '_blank');
        toast.success('Etiqueta descargada');
        setDownloadModal(false);
      } else {
        toast.error('Error al descargar la etiqueta');
      }
    } catch {
      toast.error('Ha ocurrido un error al intentar descargar la etiqueta');
    }
  };

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if (!order?.orderId || !clientId) return;
      setLoading(true);
      setError(false);
      const http = initializeHttpProvider();
      try {
        const response = await http.mlParcel.order({ orderId: order.orderId, clientId });
        setOrderData((response as IResOrder).data[0]);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen && order) {
      fetchOrderDetails();
    }
  }, [isOpen, order, clientId]);

  return { downloadModal, handleDownloadModal, orderData, loading, error, downloadLabels };
};

export default useDetailsModalParcel;
